import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { maskPhone } from '../../utils/masks';
import { ArrowLeft, MessageCircle, CheckCircle } from 'lucide-react';

export default function RecuperarSenha() {
  const [whatsapp, setWhatsapp] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/auth/forgot-password-whatsapp', {
        whatsapp: whatsapp.replace(/\D/g, ''),
      });
      setResult(res.data);
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao processar. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleSendWA = () => {
    if (!result?.token) return;
    const resetUrl = `${window.location.origin}/redefinir-senha/${result.token}`;
    const msg = `Olá${result.nome ? ' ' + result.nome : ''}! Clique no link para redefinir sua senha: ${resetUrl}`;
    const waUrl = `https://wa.me/${result.whatsapp}?text=${encodeURIComponent(msg)}`;
    window.open(waUrl, '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-brand-dark to-brand-primary flex flex-col">
      <div className="flex-1 flex flex-col justify-center px-6 py-10 max-w-sm mx-auto w-full">

        <Link to="/login" className="flex items-center gap-2 text-white/70 hover:text-white mb-8 text-sm font-body w-fit">
          <ArrowLeft className="w-4 h-4" /> Voltar ao login
        </Link>

        <div className="text-center mb-8">
          <img src="/logo-fatima.jpg" alt="Fátima Guterres" className="w-36 h-auto rounded-xl mx-auto mb-4 shadow-lg object-cover" />
          <h1 className="font-heading text-2xl text-white font-bold">Recuperar Senha</h1>
          <p className="text-white/70 text-sm mt-1 font-body">
            Informe o WhatsApp cadastrado para receber o link
          </p>
        </div>

        {!result?.found ? (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm text-white/80 mb-1.5 font-body">WhatsApp cadastrado</label>
              <input
                type="tel"
                inputMode="numeric"
                className="w-full rounded-xl border border-white/20 bg-white/10 px-4 py-3 text-white placeholder-white/40 text-sm font-body focus:outline-none focus:ring-2 focus:ring-white/40"
                placeholder="(00) 00000-0000"
                value={whatsapp}
                onChange={e => setWhatsapp(maskPhone(e.target.value))}
                required
                data-testid="whatsapp-recovery-input"
              />
            </div>

            {error && (
              <p className="text-red-300 text-sm font-body text-center">{error}</p>
            )}

            <button
              type="submit"
              disabled={loading || !whatsapp}
              className="w-full py-3.5 rounded-xl bg-white text-brand-primary font-dashboard font-bold text-sm hover:bg-white/90 transition-colors disabled:opacity-60"
              data-testid="submit-recovery-btn"
            >
              {loading ? 'Buscando...' : 'Continuar'}
            </button>

            {result && !result.found && (
              <p className="text-amber-300 text-sm text-center font-body">
                WhatsApp não encontrado no sistema.
              </p>
            )}
          </form>
        ) : (
          <div className="space-y-5 text-center">
            <div className="w-14 h-14 bg-green-500 rounded-full flex items-center justify-center mx-auto">
              <CheckCircle className="w-7 h-7 text-white" />
            </div>
            <div>
              <p className="text-white font-dashboard font-bold text-lg">Link gerado!</p>
              <p className="text-white/70 text-sm font-body mt-1">
                Clique no botão abaixo para abrir o WhatsApp. O link será pré-preenchido — basta enviar para você mesmo.
              </p>
            </div>

            <button
              onClick={handleSendWA}
              className="w-full py-3.5 rounded-xl bg-green-500 text-white font-dashboard font-bold text-sm flex items-center justify-center gap-2 hover:bg-green-600 transition-colors"
              data-testid="send-wa-btn"
            >
              <MessageCircle className="w-5 h-5" />
              Enviar link no meu WhatsApp
            </button>

            <button
              onClick={() => { setResult(null); setWhatsapp(''); }}
              className="text-white/60 text-sm font-body underline"
            >
              Usar outro número
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
